import "./Capabilities.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import CapabilitiesHero from "./sections/CapabilitiesHero";
import Capabilities from "./sections/Capabilities";
import ProcessLink from "./sections/ProcessLink";
import ClosingCta from "./sections/ClosingCta";
import Footer from "@/reusable_sections/Footer";
export default function CapabilitiesPage() {
  return <div className="min-h-screen bg-background text-foreground">
      <Header />
      <PageBreadcrumb page="Capabilities" />
      <CapabilitiesHero />
      <Capabilities />
      <ProcessLink />
      <ClosingCta />
      <Footer />
    </div>;
}